export type ZoomDirection = 'in' | 'out'

// Escala a menos de 1% de um degrau de distância conta como estando nele: cobre
// ruído de ponto flutuante e cliques no fim da animação (ex.: 1.497 rumo a 1.5).
const STEP_TOLERANCE = 0.01

/**
 * Retorna o próximo múltiplo de `step` na direção pedida, limitado a
 * `[min, max]`. Uma escala fora do degrau (ex.: vinda de pinch) é encaixada
 * no múltiplo vizinho: 1.37 vai para 1.5 (in) ou 1 (out).
 */
const getSteppedZoom = (
  current: number,
  direction: ZoomDirection,
  step: number,
  min: number,
  max: number
): number => {
  const ratio = current / step
  const target =
    direction === 'in'
      ? (Math.floor(ratio + STEP_TOLERANCE) + 1) * step
      : (Math.ceil(ratio - STEP_TOLERANCE) - 1) * step

  return Math.min(max, Math.max(min, target))
}

export default getSteppedZoom
